import type { Site } from "@lumora/bridge";
import { useViewModel } from "@lumora/ui";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ADMIN_SITE } from "../../platformClient.js";
import { useSiteOpsVm } from "./platformViewModels.js";
import { CreatePartnerForm } from "./CreatePartnerForm.js";
import { PlatformPageHeader } from "./PlatformPageHeader.js";

export function SiteRow({ site }: { site: Site }) {
  const platform = site.slug === ADMIN_SITE;
  const partner = site.kind === "partner";
  return (
    <tr>
      <td>
        {site.name}
        {partner ? (
          <>
            {" "}
            <span className="platform-console-badge">Partner</span>
          </>
        ) : null}
      </td>
      <td>
        <code>{site.slug}</code>
      </td>
      <td>{site.customDomain || "—"}</td>
      <td>{site.connectAccountEmail || "—"}</td>
      <td>
        {platform
          ? "platform (sandbox)"
          : partner
            ? "partner"
            : site.sample === false ? "live" : site.lifecycle || "sample"}
      </td>
      <td>
        {platform ? (
          <span className="platform-console-badge">Platform</span>
        ) : (
          <Link to={`/platform/sites/${site.slug}`}>Manage →</Link>
        )}
      </td>
    </tr>
  );
}

export function PlatformSitesPage() {
  const vm = useSiteOpsVm();
  const { sites, sitesError: error } = useViewModel(vm);

  const [reload, setReload] = useState(0);

  useEffect(() => {
    void vm.loadSites();
  }, [vm, reload]);

  return (
    <div className="site-platform">
      <PlatformPageHeader
        title="Sites"
        lead="Every tenant on the shared backend. Open one to manage billing, traffic, and live panels."
      />
      <div className="platform-provision-grid">
        <CreatePartnerForm onCreated={() => setReload((n) => n + 1)} />
      </div>
      {error ? <p className="ops-error">{error}</p> : null}
      {sites === null && !error ? <p className="muted">Loading…</p> : null}
      {sites && sites.length === 0 ? <p className="muted">No sites yet.</p> : null}
      {sites && sites.length > 0 ? (
        <table className="ops-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Slug</th>
              <th>Domain</th>
              <th>Connect email</th>
              <th>Status</th>
              <th>Backend</th>
            </tr>
          </thead>
          <tbody>
            {sites.map((s) => (
              <SiteRow key={s.id} site={s} />
            ))}
          </tbody>
        </table>
      ) : null}
    </div>
  );
}
